import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';

import { LoginForm, RegisterForm } from '@/features/auth';

/** Sign-in and sign-up share one page; the mode decides the form and the link. */
export function AuthPage({ mode }: { mode: 'login' | 'register' }): React.JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const done = (): void => {
    void navigate('/');
  };

  return (
    <section>
      <h1>{mode === 'login' ? t('auth.loginTitle') : t('auth.registerTitle')}</h1>
      {mode === 'login' ? <LoginForm onSuccess={done} /> : <RegisterForm onSuccess={done} />}
      <p>
        {mode === 'login' ? (
          <Link to="/register">{t('auth.toRegister')}</Link>
        ) : (
          <Link to="/login">{t('auth.toLogin')}</Link>
        )}
      </p>
    </section>
  );
}
